import axios from "axios";
import {
    authorizationServicesPath,
} from "../../Constants";

const jobRestUrl = authorizationServicesPath + '/customers/addresses'

export default class AddressCustomerService {

    static async getAll() {
        return axios.get(jobRestUrl);
    }

    static async update(data, id) {
        return await axios.put(jobRestUrl + "/" + id,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(jobRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(data) {
        return await axios.post(jobRestUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    /**
     * Создание или изменение одного адреса пользователя и его привязка.
     * addressType: ADDRESS | RESIDENTIAL_ADDRESS
     */
    static async createAndSet(addressType, data) {
        return axios.post(
            `${jobRestUrl}/create-and-set?addressType=${addressType}`,
            JSON.stringify(data),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }
}